// extracted by mini-css-extract-plugin
export var alt = "ParagraphSupportTiles-module--alt--4b00e";
export var container = "ParagraphSupportTiles-module--container--48267";
export var desktopOnly = "ParagraphSupportTiles-module--desktopOnly--552ee";
export var main = "ParagraphSupportTiles-module--main--dfd40";
export var mobileOnly = "ParagraphSupportTiles-module--mobileOnly--543ad";
export var textLeft = "ParagraphSupportTiles-module--textLeft--7abea";
export var visuallyHidden = "ParagraphSupportTiles-module--visuallyHidden--a6645";